
/// <amd-module name="WorkItemsHub/ZeroData/IllustrationUrlUtils" />
export namespace GeneralZeroDataIllustrationPaths {
    export const SomethingWrongOnServer = "ms.vss-work-web/new-work-items-hub-content/Illustrations/general-something-wrong-on-server.svg";
}

export namespace WorkZeroDataIllustrationPaths {
    export const GetBackToRecentWork = "ms.vss-work-web/new-work-items-hub-content/Illustrations/zerodata-get-back-to-recent-work.svg";
    export const KeepAnEyeOnImportantWork = "ms.vss-work-web/new-work-items-hub-content/Illustrations/zerodata-keep-an-eye-on-important-work.svg";
    export const MentionSomeone = "ms.vss-work-web/new-work-items-hub-content/Illustrations/zerodata-mention-someone.svg";
    export const YourWorkInOnePlace = "ms.vss-work-web/new-work-items-hub-content/Illustrations/zerodata-your-work-in-one-place.svg";
    export const GeneralNoResultsFound = "ms.vss-work-web/new-work-items-hub-content/Illustrations/general-no-results-found.svg";
}

export namespace WorkWidgetIllustrationPaths {
    export const YouDontHavePermission = "ms.vss-work-web/new-work-items-hub-content/Illustrations/widget-you-dont-have-permission.svg";
}
